import React from "react";
var __jsx = React.createElement;
import styles from './CarCardPlaceHolder.module.css';
export var CarCardPlaceHolder = function CarCardPlaceHolder() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.cardItem
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.imagePlaceholder
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.cardBody
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.cardTitle
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.tag
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.titlePlaceholder
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.cardPrice
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.priceText
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.cardFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.tagWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.tag
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.tag
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.tag
  }))));
};